var map = {
	"./arrow-dash.svg": 5630,
	"./award-practice.svg": 5215,
	"./award-tracking.svg": 8571,
	"./badge/badge-1.svg": 202,
	"./badge/badge-2.svg": 9178,
	"./badge/badge-3.svg": 2371,
	"./badge/badge-4.svg": 4853,
	"./badge/badge-5.svg": 1400,
	"./badge/badge-6.svg": 3399,
	"./badge/badge-7.svg": 1708,
	"./badge/badge-blank.svg": 5823,
	"./badge/trophy.svg": 2083,
	"./bonus-topic-intro/finances.svg": 6007,
	"./bonus-topic-intro/mental-health.svg": 3331,
	"./bonus-topic-intro/slip-help.svg": 4828,
	"./bonus-topic-intro/substance-use.svg": 3194,
	"./bonus-topic-menu/bonus-menu-finances.svg": 6400,
	"./bonus-topic-menu/bonus-menu-mental-health.svg": 3961,
	"./bonus-topic-menu/bonus-menu-substance-use.svg": 4445,
	"./close.svg": 6858,
	"./email.svg": 2724,
	"./facebook.svg": 5518,
	"./hamburger.svg": 9989,
	"./hide.svg": 2442,
	"./home/c4b-logo-copyright.svg": 9611,
	"./home/change4better-logo.svg": 5332,
	"./home/home-card-bonus-topics.svg": 14,
	"./home/home-card-feedback-report.svg": 2719,
	"./home/home-card-my-plans.svg": 2671,
	"./home/home-card-practice.svg": 8652,
	"./home/home-card-slip-help.svg": 8283,
	"./home/home-card-tracking-tool.svg": 4601,
	"./home/home-header-bkg.svg": 6861,
	"./home/home-topics-img.svg": 1568,
	"./icon-complete.min.svg": 1038,
	"./icon-complete.svg": 2688,
	"./icon-feedback-report.svg": 7039,
	"./icon-home.svg": 5604,
	"./icon-lock.min.svg": 4707,
	"./icon-lock.svg": 697,
	"./icon-logout.svg": 1877,
	"./icon-module-1-i.svg": 5632,
	"./icon-module-1.svg": 65,
	"./icon-module-2-i.svg": 761,
	"./icon-module-2.svg": 3068,
	"./icon-module-3-i.svg": 5762,
	"./icon-module-3.svg": 1751,
	"./icon-module-4-i.svg": 8121,
	"./icon-module-4.svg": 7511,
	"./icon-module-5-i.svg": 3106,
	"./icon-module-5.svg": 3818,
	"./icon-module-6-i.svg": 5741,
	"./icon-module-6.svg": 6130,
	"./icon-module-7-i.svg": 5763,
	"./icon-module-7.svg": 1103,
	"./icon-settings.svg": 8687,
	"./icon-tools-help.svg": 3679,
	"./icon-tools-plan.svg": 6203,
	"./icon-tools-task.svg": 5646,
	"./icon-tools-track.svg": 5015,
	"./icons/lesson-audio.svg": 322,
	"./icons/lesson-text.svg": 9305,
	"./icons/lesson-video.svg": 8453,
	"./instagram.svg": 267,
	"./kicknic-logo-new.svg": 414,
	"./kicknick-logo.svg": 1669,
	"./kudo/kudos-1.svg": 1638,
	"./kudo/kudos-2.svg": 4626,
	"./kudo/kudos-3.svg": 7176,
	"./kudo/kudos-4.svg": 3447,
	"./kudo/kudos-5.svg": 1047,
	"./kudo/kudos-6.svg": 7418,
	"./kudo/kudos-7.svg": 9710,
	"./linkedin.svg": 4728,
	"./logout.svg": 9457,
	"./misc/icon-trophy.svg": 7366,
	"./nav-arrow.svg": 9402,
	"./pinterest.svg": 4883,
	"./play-filled.svg": 6138,
	"./play-stroke.svg": 9899,
	"./practice-menu/practice-menu-avoid-triggers.svg": 9974,
	"./practice-menu/practice-menu-communication.svg": 3669,
	"./practice-menu/practice-menu-coping-with-urges.svg": 268,
	"./practice-menu/practice-menu-decision-making.svg": 6014,
	"./practice-menu/practice-menu-functional-analysis.svg": 711,
	"./practice-menu/practice-menu-problem-solving.svg": 3565,
	"./practice-menu/practice-menu-thinking-traps.svg": 2185,
	"./search.svg": 2654,
	"./section/t-s-all-checkin.svg": 4208,
	"./section/t-s-all-summary-quiz.svg": 9858,
	"./section/t1-s1-problem-gambling.svg": 1919,
	"./section/t1-s2-make-change.svg": 4816,
	"./section/t10-s2-plan-ahead.svg": 4961,
	"./section/t10-s3-recovery-plan.svg": 4365,
	"./section/t2-s2-learn-triggers.svg": 3787,
	"./section/t2-s3-dont-gamble.svg": 4384,
	"./section/t2-s4-tracking-tool.svg": 820,
	"./section/t3-s2-what-is-analysis.svg": 1892,
	"./section/t3-s3-your-analysis.svg": 2977,
	"./section/t4-s2-change-environment.svg": 4341,
	"./section/t4-s3-fill-void.svg": 4232,
	"./section/t4-s4-plan-ahead.svg": 8533,
	"./section/t4-s5-your-plan.svg": 9197,
	"./section/t5-s2-urges-gamble.svg": 9531,
	"./section/t5-s3-learn-to-cope.svg": 6133,
	"./section/t5-s4-plan-to-cope.svg": 1069,
	"./section/t6-s2-identify-myths.svg": 1812,
	"./section/t6-s3-identify-distortions.svg": 4666,
	"./section/t6-s4-practice-distortions.svg": 3740,
	"./section/t7-s2-impulsive-decisions.svg": 7598,
	"./section/t7-s3-practice-decisions.svg": 4107,
	"./section/t8-s2-steps-solving.svg": 470,
	"./section/t8-s3-practice-solving.svg": 9582,
	"./section/t9-s2-styles-communication.svg": 8440,
	"./section/t9-s3-assertive-communication.svg": 5365,
	"./section/t9-s4-practice-communication.svg": 9310,
	"./session/module-1-check-in.svg": 5487,
	"./session/module-1-facts.svg": 3047,
	"./session/module-1-plan.svg": 7074,
	"./session/module-1-ready.svg": 1340,
	"./session/module-1-summary.svg": 2343,
	"./session/module-1-team.svg": 3801,
	"./session/module-2-check-in.svg": 4329,
	"./session/module-2-coping.svg": 1120,
	"./session/module-2-plan.svg": 2213,
	"./session/module-2-summary.svg": 2542,
	"./session/module-2-triggers.svg": 6691,
	"./session/module-2-withdrawal.svg": 3239,
	"./session/module-3-check-in.svg": 3034,
	"./session/module-3-plan.svg": 8872,
	"./session/module-3-refusal.svg": 1406,
	"./session/module-3-summary.svg": 4290,
	"./session/module-4-check-in.svg": 400,
	"./session/module-4-plan.svg": 1935,
	"./session/module-4-stress.svg": 6639,
	"./session/module-4-summary.svg": 6887,
	"./session/module-5-check-in.svg": 2066,
	"./session/module-5-moods.svg": 4091,
	"./session/module-5-plan.svg": 2616,
	"./session/module-5-summary.svg": 7484,
	"./session/module-6-check-in.svg": 8613,
	"./session/module-6-decision-1.svg": 8954,
	"./session/module-6-decision-2.svg": 8443,
	"./session/module-6-plan.svg": 9785,
	"./session/module-6-summary.svg": 8161,
	"./session/module-7-check-in.svg": 4996,
	"./session/module-7-future.svg": 794,
	"./session/module-7-plan.svg": 1819,
	"./session/module-7-summary.svg": 7689,
	"./show.svg": 3174,
	"./sp/intro/intro-cognitive-restructuring-catching-ants.svg": 1985,
	"./sp/intro/intro-cognitive-restructuring-cbt-triangle.svg": 1916,
	"./sp/intro/intro-cognitive-restructuring-defusion-techniques.svg": 8007,
	"./sp/intro/intro-cognitive-restructuring-real-odds.svg": 4061,
	"./sp/intro/intro-cognitive-restructuring-restructuring-strategies.svg": 8482,
	"./sp/intro/intro-cognitive-restructuring-thinking-traps.svg": 2611,
	"./sp/intro/intro-goal-setting-closing.svg": 6627,
	"./sp/intro/intro-goal-setting-pacing.svg": 2250,
	"./sp/intro/intro-goal-setting-pleasant-activities.svg": 6934,
	"./sp/intro/intro-goal-setting-smart-goals.svg": 1397,
	"./sp/intro/intro-pain-education-intro.svg": 1660,
	"./sp/intro/intro-pain-education-opioid.svg": 9302,
	"./sp/intro/intro-pain-education-surgery.svg": 779,
	"./sp/intro/intro-relaxation-grounding-tools.svg": 6441,
	"./sp/intro/intro-relaxation-mental-exercises.svg": 9099,
	"./sp/intro/intro-sleep-cog-restructuring.svg": 1978,
	"./sp/intro/intro-sleep-hygiene-assessment.svg": 9337,
	"./sp/intro/intro-sleep-other-resources.svg": 8310,
	"./sp/intro/intro-welcome-self-assessment.svg": 8901,
	"./sp/lesson/cognitive-restructuring-lesson-menu.svg": 5382,
	"./sp/lesson/goal-setting-lesson-menu.svg": 160,
	"./sp/lesson/pain-education-lesson-menu.svg": 5712,
	"./sp/lesson/relaxation-lesson-menu.svg": 4857,
	"./sp/lesson/sleep-lesson-menu.svg": 4322,
	"./sp/lesson/welcome-lesson-menu.svg": 6830,
	"./sp/spinepal-logo-full.svg": 5593,
	"./sp/spinepal-logomark.svg": 5906,
	"./sp/spinepal-wordmark.svg": 640,
	"./sp/topic/exercises-card.svg": 5737,
	"./sp/topic/my-goal-card.svg": 3451,
	"./sp/topic/topic-card-cognitive-restructuring.svg": 2895,
	"./sp/topic/topic-card-goal-setting.svg": 9103,
	"./sp/topic/topic-card-pain-education.svg": 9104,
	"./sp/topic/topic-card-relaxation.svg": 2215,
	"./sp/topic/topic-card-sleep.svg": 4305,
	"./sp/topic/topic-card-welcome.svg": 2350,
	"./sp/ui/icon-edit.svg": 3365,
	"./sp/ui/status-complete.svg": 9446,
	"./toast/toast-modal-1.svg": 2311,
	"./toast/toast-modal-2.svg": 4602,
	"./toast/toast-modal-3.svg": 8667,
	"./topic-complete.svg": 2670,
	"./topic-intro/icon-topic-1.svg": 2499,
	"./topic-intro/icon-topic-10.svg": 6399,
	"./topic-intro/icon-topic-2.svg": 1596,
	"./topic-intro/icon-topic-3.svg": 8698,
	"./topic-intro/icon-topic-4.svg": 719,
	"./topic-intro/icon-topic-5.svg": 5535,
	"./topic-intro/icon-topic-6.svg": 3668,
	"./topic-intro/icon-topic-7.svg": 2322,
	"./topic-intro/icon-topic-8.svg": 2179,
	"./topic-intro/icon-topic-9.svg": 9552,
	"./topic-menu/topic-menu-1.svg": 1914,
	"./topic-menu/topic-menu-10.svg": 8599,
	"./topic-menu/topic-menu-2.svg": 7087,
	"./topic-menu/topic-menu-3.svg": 7033,
	"./topic-menu/topic-menu-4.svg": 9986,
	"./topic-menu/topic-menu-5.svg": 226,
	"./topic-menu/topic-menu-6.svg": 6990,
	"./topic-menu/topic-menu-7.svg": 8265,
	"./topic-menu/topic-menu-8.svg": 8532,
	"./topic-menu/topic-menu-9.svg": 4848,
	"./twitter.svg": 3435,
	"./ui/icon-back-arrow.svg": 8899,
	"./ui/icon-next-arrow.svg": 9414,
	"./ui/menu.svg": 346,
	"./urge-surfing-4.svg": 9870,
	"./urge-surfing-5.svg": 329,
	"./urge-surfing.svg": 9316,
	"./youtube.svg": 7182
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7583;